import React from 'react';
import { Box } from '@mui/material';
import styled from 'styled-components';

export const RecordContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 20px;
  background-color: ${({ theme }) => theme.palette.grey[100]};
`;

export const RecordHeaderContainer = styled(Box)`
  margin-bottom: 10px;
`;

export const RecordBodyContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex: 1;
  gap: 10px;
`;

export const ContentContainer = styled(Box)<{
  $maxHeight: string | null;
}>`
  display: flex;
  flex: 6 1 0px;
  flex-direction: column;
  max-height: ${(props) => (props.$maxHeight ? `${props.$maxHeight}px` : 'none')};
  margin-bottom: 20px;
  & {
    max-height: 100%;
  }
  min-width: 0;
`;

export const ActivitiesContainer = styled(Box)<{
  height: number;
  top?: number;
  $width?: number;
}>`
  display: flex;
  flex: 4 1 0px;
  flex-direction: column;
  align-self: flex-start;
  position: sticky;
  top: ${(props) => props.top || 0};
  height: ${(props) => props.height}px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  background: ${({ theme }) => theme.palette.common.white};
  margin-bottom: 20px;
  box-sizing: border-box;
  max-width: 50%;
  ${({ $width }) => ($width ? `flex: 0 0 ${$width}px; max-width: ${$width}px;` : '')}
`;

export const ActivitiesContentContainer = styled(Box)`
  overflow-x: hidden;
  overflow-y: auto;
  padding: 24px;
  padding-top: 10px;
  flex: 1;
`;

export const ActivitiesFooterContainer = styled(Box)`
  padding: 24px;
  padding-top: 30px;
`;

export const ActivitiesInnerContainer = styled.span`
  padding: 24px;
`;
